"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));

var _GridAreaContainer = _interopRequireDefault(require("@sprinx/react-mui-components/GridAreaContainer"));

var _makeStyles = _interopRequireDefault(require("@material-ui/core/styles/makeStyles"));

var _useIsAuthenticated = _interopRequireDefault(require("@sprinx/react-auth/useIsAuthenticated"));

var _useSnackbar3 = _interopRequireDefault(require("@sprinx/react-mui-layout/useSnackbar"));

var _useTranslate = _interopRequireDefault(require("@sprinx/react-globalize/useTranslate"));

var _FavoriteBorder = _interopRequireDefault(require("@material-ui/icons/FavoriteBorder"));

var _useUserFavoritesForProduct = _interopRequireDefault(require("../../favorites/useUserFavoritesForProduct"));

var _withNullIfStaticBuild = _interopRequireDefault(require("../../withNullIfStaticBuild"));

var useStyles = (0, _makeStyles.default)(function (theme) {
  return {
    root: {},
    icon: {
      fill: theme.palette.another.grey
    },
    active: {
      fill: theme.palette.common.black
    }
  };
});

function FavoriteButton(_ref) {
  var pClasses = _ref.classes,
      className = _ref.className,
      product = _ref.product,
      renderToGridArea = _ref.renderToGridArea,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["classes", "className", "product", "renderToGridArea"]);
  var classes = useStyles({
    classes: pClasses
  });
  var t = (0, _useTranslate.default)();

  var _useSnackbar = (0, _useSnackbar3.default)(),
      _useSnackbar2 = (0, _slicedToArray2.default)(_useSnackbar, 1),
      showMessage = _useSnackbar2[0];

  var isAuth = (0, _useIsAuthenticated.default)();

  var _useUserFavoritesForP = (0, _useUserFavoritesForProduct.default)(product),
      handleAdd = _useUserFavoritesForP.handleAdd,
      handleRemove = _useUserFavoritesForP.handleRemove,
      isFavorite = _useUserFavoritesForP.isFavorite;

  var handleChange = _react.default.useCallback(function () {
    if (isFavorite) {
      handleRemove();
      showMessage(t('favorite/removeFromFavorite'), {
        variant: 'success'
      });
    } else {
      handleAdd();
      showMessage(t('favorite/addToFavorite'), {
        variant: 'success'
      });
    }
  }, [handleAdd, handleRemove, isFavorite, showMessage, t]);

  return isAuth ? /*#__PURE__*/_react.default.createElement(_GridAreaContainer.default, (0, _extends2.default)({}, rest, {
    renderToGridArea: renderToGridArea,
    className: (0, _clsx.default)(classes.root, className)
  }), /*#__PURE__*/_react.default.createElement(_IconButton.default, {
    onClick: handleChange
  }, /*#__PURE__*/_react.default.createElement(_FavoriteBorder.default, {
    className: (0, _clsx.default)(classes.icon, isFavorite && classes.active)
  }))) : null;
}

process.env.NODE_ENV !== "production" ? FavoriteButton.propTypes = {
  classes: _propTypes.default.shape({
    active: _propTypes.default.string,
    icon: _propTypes.default.string,
    root: _propTypes.default.string
  }),
  className: _propTypes.default.string,
  product: _propTypes.default.shape({
    id: _propTypes.default.string.isRequired
  }).isRequired,
  renderToGridArea: _propTypes.default.string
} : void 0;
FavoriteButton.defaultProps = {
  classes: undefined,
  className: undefined,
  renderToGridArea: 'actions'
};
var FavoriteButtonComposed = (0, _withNullIfStaticBuild.default)(FavoriteButton);
var _default = FavoriteButtonComposed;
exports.default = _default;